module.exports = __webpack_public_path__ + "img/tick1.a1924b7.svg";